(function () {
  function getCurrentVariantId(scope) {
    const checkedRadio = scope.querySelector('input[name="id"]:checked');
    if (checkedRadio?.value) return checkedRadio.value;

    const select = scope.querySelector('select[name="id"]');
    if (select?.value) return select.value;

    const anyIdInput = scope.querySelector('input[name="id"]');
    if (anyIdInput?.value) return anyIdInput.value;

    return null;
  }

  function updateBadges(scope) {
    const badges = scope.querySelectorAll('[data-repedia-badge]');
    if (!badges.length) return;

    const currentVariantId = getCurrentVariantId(scope);
    badges.forEach(badge => {
      const raw = (badge.dataset.originalVariantIds || '').trim();
      const ids = raw ? raw.split(',').filter(Boolean) : [];
      const shouldShow = currentVariantId && ids.includes(String(currentVariantId));
      badge.classList.toggle('is-hidden', !shouldShow);
    });
  }

  function boot() {
    updateBadges(document);

    document.addEventListener('change', function (e) {
      const t = e.target;
      if (!t) return;
      // reicht meist: sobald irgendwas im Product-Form changed -> refresh
      if (t.closest('form[action*="/cart/add"]') || t.matches('input[name="id"], select[name="id"]')) {
        updateBadges(document);
      }
    });

    ['variant:change', 'variant:changed', 't4s:variant:change', 't4s:variant_changed'].forEach(evt => {
      document.addEventListener(evt, function () {
        updateBadges(document);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();